<template>
  <div
    :class="`customized-goods-group ${classNameType}`"
    :style="`backgroundColor: ${setData.backgroundColor};`"
  >
    <div :class="`tabs ${tabsClassName}`">
      <div class="tab-box" v-for="(item, index) in contentData" :key="index">
        <div
          class="tab"
          :style="`color: ${setData.titleTextColor}`"
          :class="activeObj.name == item.name ? 'active' : ''"
          @click="activeObj = item"
        >
          {{ item.name }}
        </div>
        <div
          class="line"
          v-if="setData.titleDelimiter && index + 1 < contentData.length"
        ></div>
      </div>
    </div>
    <Goods :contentData="activeObj.list" :setData="setData" />
  </div>
</template>

<script>
import Goods from './Goods'
export default {
  name: 'GoodsGroup',
  components: {
    Goods,
  },
  props: {
    contentData: {
      type: Array,
      default: () => [],
    },
    setData: {
      type: Object,
      default: () => {
        return {
          showType: 'one', // 展示方式 one two
          backgroundColor: '#fff999', // 背景颜色
          titleTextColor: '#333', // 分组名称文字颜色
          titleAlignType: 'left', // 商品分组标题对齐方式 left center
          titleDelimiter: true, // 分组名称分隔符
          topSpace: 'big', // 上边距 small medium big
          bottomSpace: 'big', // 下边距 small medium big
        }
      },
    },
  },
  data() {
    return {
      classNameType: `topSpace-${this.setData.topSpace} bottomSpace-${this.setData.bottomSpace}`,
      tabsClassName: `titleAlignType-${this.setData.titleAlignType}`,
      active: 1,
      activeObj: this.contentData[0],
    }
  },
  created() {
    console.log('$$$$$$$$$$$$$$$44this.contentData')
    console.log(this.contentData)
  },
  methods: {},
}
</script>

<style lang="less" scoped>
.customized-goods-group {
  width: 375px;
  .tabs {
    box-sizing: border-box;
    width: 100%;
    overflow-x: scroll;
    padding: 0 8px;
    height: 26px;
    background: #ffffff;
    display: inline-flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    .tab-box {
      position: relative;
      .tab {
        position: relative;
        margin: 0 12px;
        height: 100%;
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        opacity: 0.36;
        line-height: 20px;
        white-space: nowrap;
      }
      .line {
        position: absolute;
        top: 20%;
        right: 0;
        width: 1px;
        height: 10px;
        background-color: #dddddd;
      }
      .tab:last-child::before {
        display: none;
      }
      .active {
        font-weight: 500;
        opacity: 1;
      }
      .active::after {
        content: '';
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        width: 14px;
        height: 3px;
        background: #ff4e4e;
        border-radius: 2px;
      }
    }
  }
  .titleAlignType-center {
    justify-content: center;
  }
}
.topSpace-medium {
  padding-top: 10px;
}
.topSpace-big {
  padding-top: 15px;
}
.bottomSpace-medium {
  padding-bottom: 10px;
}
.bottomSpace-big {
  padding-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/view/customize/customizedComponents/GoodsGroup.vue